module.exports = __webpack_public_path__ + "img/logo.ba50de79.svg";